// Module
var code = "<template>\n    <input disabled.bind=\"disabled\" type=\"text\" class=\"form-control\" ref=\"input\" />\n</template>\n";
// Exports
export default code;